// @flow
import { graphql } from 'react-relay';
import createRelayMutation from 'shared/gql/createRelayMutation';

const mutation = graphql`
  mutation ValidateCSVImportMutation($input: ValidateCSVImportInput!) {
    validateCSVImport(input: $input) {
      validationResult {
        valid
        errors
        totalErrors
        newCount
        updateCount
      }
    }
  }
`;

export default ({ variables }: Object) =>
  createRelayMutation(mutation, { variables });
